import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [RotateRight, AnimatedRotateRight] = createIcon({
  name: 'RotateRight',
  getIcon: (props) => (
    <Svg viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M14.6667 2.6665V5.99984C14.6667 6.36784 14.3687 6.6665 14 6.6665H10.6667C10.298 6.6665 10 6.36784 10 5.99984C10 5.63184 10.298 5.33317 10.6667 5.33317H12.6066C11.6686 3.70984 9.92468 2.6665 8.00001 2.6665C5.05934 2.6665 2.66668 5.05917 2.66668 7.99984C2.66668 10.9405 5.05934 13.3332 8.00001 13.3332C10.0387 13.3332 11.8687 12.1978 12.7761 10.3698C12.9394 10.0405 13.3406 9.90451 13.6693 10.0692C13.9993 10.2332 14.1341 10.6332 13.9701 10.9626C12.8361 13.2472 10.548 14.6659 8.00001 14.6659C4.32401 14.6659 1.33334 11.6752 1.33334 7.99919C1.33334 4.32319 4.32401 1.33252 8.00001 1.33252C10.1353 1.33252 12.098 2.35589 13.3333 4.00456V2.6665C13.3333 2.2985 13.6313 1.99984 14 1.99984C14.3687 1.99984 14.6667 2.2985 14.6667 2.6665Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </Svg>
  ),
})
